import { toLocaleNumber } from '@chr/online-shared-ui-localizations';

type NullableNumber = number | null | undefined;

export const formatNumber = (
  value: NullableNumber,
  fixedTo?: number,
  defaultString?: string,
): string => {
  if ((value === undefined || value === null) && !!defaultString) {
    return defaultString;
  }

  const formattedValue = !value ? 0 : value;
  const decimalPlaces = !fixedTo ? 0 : fixedTo;

  return toLocaleNumber(formattedValue, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
};

export const formatNumberWithUnits =
  (num: NullableNumber, unitLabel: string, decimalScale: number = 2) => `${formatNumber(num, decimalScale)} ${unitLabel}`;

export const formatWeight =
  (weight: NullableNumber, unitLabel: string) => formatNumberWithUnits(weight, unitLabel, 3);